export default "__VITE_ASSET__BuCl9gCm__"